var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.828,
    viewBox: "0 0 14 14.828"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ArrowRightGrey_svg__arrow_right_b{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    className: "ArrowRightGrey_svg__arrow_right_b",
    d: "M1 7.414h12M7 1.414l6 6-6 6"
  }))));
}

export default SvgArrowRightGrey;